import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Authenticated requests (admin) — sends cookies
export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Public requests (landing page) — no cookies, more permissive cross-origin behavior on strict mobile browsers (Safari especially).
// Cache-Control headers + per-call cache-busting prevent iOS Safari's aggressive GET caching.
export const publicApi = axios.create({
  baseURL: API,
  withCredentials: false,
  timeout: 12000,
  headers: {
    "Cache-Control": "no-cache",
    "Pragma": "no-cache",
  },
});

// Auto-append a cache-buster timestamp to every GET request
publicApi.interceptors.request.use((config) => {
  if ((config.method || "get").toLowerCase() === "get") {
    config.params = { ...(config.params || {}), _t: Date.now() };
  }
  return config;
});

// Lightweight retry helper for fragile mobile networks
export async function withRetry(fn, { attempts = 3, baseMs = 400 } = {}) {
  let lastErr;
  for (let i = 0; i < attempts; i++) {
    try {
      return await fn();
    } catch (e) {
      lastErr = e;
      if (i < attempts - 1) {
        await new Promise((r) => setTimeout(r, baseMs * Math.pow(2, i)));
      }
    }
  }
  throw lastErr;
}

// BRANCHES moved to /lib/brand.js — re-exported here for backwards compat.
export { BRANCHES } from "./brand";

export function formatDate(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  return d.toLocaleString("en-US", { dateStyle: "medium", timeStyle: "short" });
}

export function formatET(date, time) {
  if (!date) return "";
  const [y, m, d] = date.split("-").map((s) => parseInt(s, 10));
  const dt = new Date(y, m - 1, d);
  const dateLabel = dt.toLocaleDateString("en-US", { weekday: "short", month: "short", day: "numeric" });
  return `${dateLabel}${time ? ` · ${time} ET` : ""}`;
}
